export default ".demo-jing-tabs {\n    overflow: visible;\n}"